import { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send, Sparkles } from "lucide-react";
import { API } from "@/App";

const SUGGESTIONS = ["SIP kitna karein?", "Health insurance ka best plan?", "ITR file kaise karein?", "PAN card banwana hai"];

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Namaste! Main Bima Mitra hoon — Bima Bachat Bazar ka AI assistant. Insurance, SIP, Tax ya CSC services ke baare mein kuch bhi poochiye." },
  ]);
  const sessionRef = useRef(`web-${Math.random().toString(36).slice(2, 10)}`);
  const listRef = useRef(null);

  useEffect(() => {
    listRef.current?.scrollTo({ top: listRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, open]);

  const send = async (text) => {
    const message = (text ?? input).trim();
    if (!message || busy) return;
    setInput("");
    setBusy(true);
    setMessages((prev) => [...prev, { role: "user", text: message }, { role: "assistant", text: "" }]);
    try {
      const response = await fetch(`${API}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionRef.current, message }),
      });
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop();
        for (const part of parts) {
          if (!part.startsWith("data: ")) continue;
          const payload = part.slice(6);
          if (payload === "[DONE]") continue;
          try {
            const { delta } = JSON.parse(payload);
            setMessages((prev) => {
              const next = [...prev];
              next[next.length - 1] = { role: "assistant", text: next[next.length - 1].text + delta };
              return next;
            });
          } catch { /* partial chunk */ }
        }
      }
    } catch {
      setMessages((prev) => {
        const next = [...prev];
        next[next.length - 1] = { role: "assistant", text: "Abhi connection mein dikkat hai. Aap WhatsApp karein: 8858187397" };
        return next;
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button className="chat-fab" onClick={() => setOpen(!open)} data-testid="chat-widget-toggle" aria-label="AI Assistant">
        {open ? <X size={22} /> : <Sparkles size={22} />}
      </button>
      {open && (
        <div className="chat-panel" data-testid="chat-panel">
          <div className="chat-head">
            <span className="chat-avatar"><Sparkles size={16} /></span>
            <div><strong>Bima Mitra</strong><small>AI Assistant • Online</small></div>
          </div>
          <div className="chat-messages" ref={listRef} data-testid="chat-messages">
            {messages.map((m, i) => (
              <div key={i} className={m.role === "user" ? "chat-msg user" : "chat-msg bot"} data-testid={`chat-message-${i}`}>
                {m.text ? m.text.replace(/\*\*/g, "") : (busy && i === messages.length - 1 ? <span className="chat-typing">typing…</span> : "")}
              </div>
            ))}
          </div>
          <div className="chat-suggestions">
            {SUGGESTIONS.map((s) => (
              <button key={s} onClick={() => send(s)} disabled={busy} data-testid={`chat-suggestion-${s.slice(0, 12).replaceAll(" ", "-").toLowerCase()}`}>{s}</button>
            ))}
          </div>
          <form className="chat-input" onSubmit={(e) => { e.preventDefault(); send(); }}>
            <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Apna sawaal likhiye…" data-testid="chat-input" maxLength={800} />
            <button type="submit" disabled={busy || !input.trim()} data-testid="chat-send-button" aria-label="Send"><Send size={17} /></button>
          </form>
          <div className="chat-note">AI jawab sirf guidance ke liye hain. Final salah ke liye Utkarsh ji se baat karein.</div>
        </div>
      )}
      {!open && (
        <a className="wa-fab" href="https://wa.me/918858187397" target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp-button" aria-label="WhatsApp">
          <MessageCircle size={24} />
        </a>
      )}
    </>
  );
}
